import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  private baseUrl: string | undefined;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
   }

   getFooter(): Observable<Response> {
    const url = `${this.baseUrl}api/WebsiteSettings/GetFooter`;
    return this.http.get<Response>(url);
  }

}
